import * as React from 'react';

import SubscriptionBoxCtrl from '@webapp/controllers/subscription/subscription-box';
import SubscriptionsItemListCtrl from '@webapp/controllers/subscription/subscription-list';
import SubscriptionsInvoicesCtrl from '@webapp/controllers/subscription/subscription-invoices';
import {
  EntitySubscription,
  ListSubscriptionsResponse,
} from '@common/types/subscription-manager/list-subscriptions-response';
import { pluralize } from '@webapp/utils/pluralize';

interface SubscriptionsListProps {
  className?: string;
  category: keyof ListSubscriptionsResponse;
  subscriptions?: EntitySubscription[];
}

const SubscriptionsList: React.FC<SubscriptionsListProps> = ({
  className,
  category,
  subscriptions,
}) => {
  if (!subscriptions) {
    return null;
  }

  const getBoxText = (subscription: EntitySubscription) => {
    if (subscription.expiring) {
      return `${subscription.expiring} expiring ${pluralize(
        'subscription',
        subscription.expiring
      )}`;
    }
    return `${subscription.active} active ${pluralize(
      'subscription',
      subscription.active
    )}`;
  };

  return (
    <div className={`${className || ''}`}>
      {subscriptions.map((subscription) => (
        <SubscriptionBoxCtrl
          key={subscription.id}
          title={subscription.name}
          avatar={subscription.avatar}
          boxText={getBoxText(subscription)}
        >
          <SubscriptionsItemListCtrl
            className="mb-40"
            category={category}
            subscription={subscription}
          />
          <SubscriptionsInvoicesCtrl
            category={category}
            subscription={subscription}
          />
        </SubscriptionBoxCtrl>
      ))}
    </div>
  );
};

export default SubscriptionsList;
